import { render } from "./SlideStylePanel.vue?vue&type=template&id=64e5ab2a&scoped=true&ts=true"
import script from "./SlideStylePanel.vue?vue&type=script&lang=ts"
export * from "./SlideStylePanel.vue?vue&type=script&lang=ts"

import "./SlideStylePanel.vue?vue&type=style&index=0&id=64e5ab2a&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e5ab2a"]])

export default __exports__